import type { ComponentProps } from "react";
import BaseActionButton from "./BaseActionButton";

type BackButtonProps = Omit<
    ComponentProps<typeof BaseActionButton>,
    "iconType" | "iconPosition" | "testId" | "buttonType" | "label" | "loadingText"
> & {
    label?: string;
    loadingText?: string;
    variant?: ComponentProps<typeof BaseActionButton>["variant"];
};

const BackButton = ({
    label = "Back",
    loadingText = "Going back...",
    variant = "secondary",
    ...props
}: BackButtonProps) => {
    return (
        <BaseActionButton
            label={label}
            loadingText={loadingText}
            iconType="back"
            iconPosition="leading"
            testId="back-button"
            buttonType="button"
            variant={variant}
            {...props}
        />
    );
};

export default BackButton;
